import axiosPost from '../axiosPost';

export const UsuarioHooliDel = async (arg) => {
    const name = 'Usuario Del';
    let result;

    const { params } = arg

    const body = {
        "service": "UsuarioHooliDel",
        "params": params ? params : {}
    }

    try {
        result = await axiosPost('Y', body, arg)
    } catch (err) {
        console.log(err)
    }

    if(result?.data){
        return result.data
    } else return result
}